import { Step } from "react-joyride";

/**
 * Guided tour steps for the RFx Settings → Submission Compliance tab.
 *
 * Each step targets a `data-testid` rendered on the tab. The row-level targets
 * (drag handle, edit, delete) only exist when at least one question row is
 * present — the tab injects a temporary, non-persisted demo row while the tour
 * runs (via the InstructionsInfoBox `onBeforeShowMe`/`onAfterShowMe` hooks) so
 * these steps always have something to point at. Joyride auto-skips any target
 * that isn't in the DOM.
 */
export const submissionComplianceSteps: Step[] = [
	{
		target: '[data-testid="compliance-question-add-input"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Add a question</h3>
				<p>
					Type a compliance question here — for example &quot;Valid insurance
					certificate provided?&quot; — then press Enter or click{" "}
					<strong>Add question</strong>. These are the questions your RFx Lead
					checks each supplier against before scoring.
				</p>
			</div>
		),
		placement: "top",
		disableBeacon: true,
	},
	{
		target: '[data-testid="compliance-question-drag-handle"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Reorder questions</h3>
				<p>
					Grab this handle and drag a question up or down to change its order.
					The order you set here is the order the questions appear in the
					evaluation compliance check.
				</p>
			</div>
		),
		placement: "right",
		disableBeacon: true,
	},
	{
		target: '[data-testid="compliance-question-edit-btn"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Edit a question</h3>
				<p>
					Click the pencil to rename a question inline. Save with the tick or
					discard your change with the cross.
				</p>
			</div>
		),
		placement: "left",
		disableBeacon: true,
	},
	{
		target: '[data-testid="compliance-question-delete-btn"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Delete a question</h3>
				<p>
					Click the bin to remove a question. You&apos;ll be asked to confirm
					first so you don&apos;t delete one by accident.
				</p>
			</div>
		),
		placement: "left",
		disableBeacon: true,
	},
];
